module.exports = __webpack_public_path__ + "static/media/change-direction-btn.da8e4b76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/change-direction-btn.svg
// module id = 718
// module chunks = 0